
/*
  前缀：
  ph_ 输入框placeholder
  tip_ 校验提示信息
  confirm_ 二次确认提示
  message_ 一般性描述
  header_ 表格header
*/
export default {
  projectOutlined: '验收项目',
  documentManagement: '文档管理',
  questionCircleOutlined: '帮助文档',
  manual: '验收端操作手册',
  login_title: 'DOTS-AD自动驾驶标注平台',
  user: '用户',
  team: '团队',
  client: '企业',
  internal: '内部',
  login: '登录',
  recommend: '推荐使用谷歌浏览器，您将获得最佳使用体验~',
  copyright: '©版权所有：北京海天瑞声科技股份有限公司 京ICP备12041558号-1',
  register: '注册',
  forget: '忘记密码',
  acceptance_project: '验收项目',
  header_project_id: '项目ID',
  header_project_name: '项目名称',
  project_id: '项目ID',
  project_id_colon: '项目ID：',
  project_name: '项目名称',
  project_name_colon: '项目名称：',
  look_up: '查看',
  view_data: '查看数据',
  look_up_all_frame: "查看全部帧",
  statistics: '统计',
  total_count: '提验总数',
  pending_count: '待验收数',
  checking_count: '正在验收数',
  passing_count: '验收通过数',
  passing_count_msg: '验收任务状态为“验收通过”的所有数据 + 验收任务状态为“待验收/验收中/验收驳回” 且 数据状态为“验收通过”的数据',
  operate: '操作',
  is_admin: '是否管理员',
  check_batch_id: '验收批次ID',
  check_status: '验收状态',
  inspector: '验收员',
  inspector1: '验收人',
  examine_time: '抽检时间',
  examine: '抽检',
  pass: '通过',
  reject: '驳回',
  acceptance_examine: '验收抽检',
  check_proportion: '请输入数据抽检比例',
  check_message: '请输入(0, 100)之间的整数',
  check_invalid: '包含无效数据',
  check_frame_proportion: '请输入帧抽检比例',
  ph_check_frame_proportion: '从被抽到的每条数据里抽检帧的百分比',
  check_batch_list: '验收批次列表',
  check_confirm: '抽检数据尚有{num}条未验收, 确定批量【{type}】未验收数据？',
  // not_accepted: '未被抽检',
  not_accepted: '未验收',
  to_be_checked: '待验收',
  checking: '验收中',
  check_revoked: '已撤销',
  check_reject: '验收驳回',
  check_pass: '验收通过',
  comprehensive_check_pass: '综合验收通过',
  comprehensive_check_pass_msg: '验收任务状态为“验收通过”的所有数据 + 验收任务状态为“待验收/验收中/验收驳回” 且 数据状态为“验收通过”的数据',
  check_pass_msg: '数据状态为“验收通过”的数据',

  inspection_data_frame: '提验数据/提验帧数/提验有效帧数',
  spot_data_fame: '抽检数据/抽检帧数',
  pass_frame_count: '验收合格帧数',
  fail_frame_count: '验收不合格帧数',
  frame_pass_rate: '帧合格率',
  inspection_data_frame1: '提验数据/提验视频数/提验有效视频数',
  spot_data_fame1: '抽检数据/抽检视频数',
  pass_frame_count1: '验收合格视频数',
  fail_frame_count1: '验收不合格视频数',
  frame_pass_rate1: '视频合格率',
  object_pass_rate: '对象合格率',
  object_pass_rate_manual: '人工框合格率',
  object_pass_rate_not_manual: '预标注合格率',
  start_check_at: '抽检时间',
  submitted_at: '完成时间',
  check_time: '验收耗时',

  examine_number: '抽检帧数/合格帧数/不合格帧数',
  examine_number1: '抽检视频数/合格视频数/不合格视频数',
  check_date: '验收日期',
  project_inspector_statistics: '项目验收统计',
  project_statistics: '项目统计',
  batch_statistics: '验收批次统计',
  check_record: '验收记录',

  check_num: '已验收数据量',
  check_frame_num: '已验收帧数',
  check_frame_num1: '已验收视频数',
  object_total_count: '对象数', // 产品要求改成对象数
  project_points_accuracy: '项目点准率',
  batch_points_accuracy: '批次点准率',
  pre_object_total_count: '已验收预标注对象数',
  check_data_rate: '数据合格率',
  check_frame_rate: '帧合格率',
  check_frame_rate1: '视频合格率',
  check_frame_precise_rate: '帧准率',
  check_object_rate: '对象合格率（总）',
  object_statistics: '对象统计',
  object_rate: '对象合格率',
  two_point_five_d: '2.5D',
  point: '点',
  line: '线',
  box: '立体框',
  rectangle: '矩形框',
  rectangle3: '矩形',
  polygon: '多边形',
  oval: '椭圆',
  sidebox: '日型框',
  pseudo: '2.5D框',
  pseudo2: '立体框',
  rectangle_3d: '点云框',
  line_3d: '点云线',
  line_length: '线长',
  polygon_3d: '点云多边形',
  rectangle2_3d: '点云矩形',
  rectangle2_2d: '空间矩形',
  point_3d: '点云点',
  date: '日期',
  register_title: '视觉标注平台注册',
  nationality: '国籍',
  tip_choose_country: '请选择国家',
  now_address: '当前所在地',
  domestic: '国内',
  abroad: '国外',
  account_type: '账号类型',
  phone: '手机号',
  email: '邮箱',
  supplier_name: '团队名称',
  ph_supplier: '请填写团队名称',
  name: '姓名：',
  name1: '名称',
  ph_choose_supplier: '请选择团队',
  ph_name: '请填写姓名',
  ph_account_name: '请输入姓名或账号',
  login_phone: '登录手机号',
  ph_phone: '请填写手机号',
  login_email: '登录邮箱',
  ph_email: '请填写邮箱',
  password: '密码',
  ph_pass_len: '需含英文和数字，8位以上',
  confirm_pass: '确认密码',
  ph_confirm_pass: '请填写确认密码',
  tissue_id: '组织ID',
  ph_tissue_id: '请填写组织ID',
  ph_ver_code: '请填写验证码',
  ph_login_ver_code: '请输入Google验证码',
  ver_code: '验证码',
  get_ver_code: '获取验证码',
  ph_pass: '请填写密码',
  tip_pass: '长度为8~14;字母数字以及标点符号至少包含2种;不允许有空格、中文',
  tip_phone_format: '手机号格式不正确',
  tip_email_format: '邮箱格式不正确',
  tip_pass_len: '密码长度不能小于8位',
  tip_pass_match: '密码与确认密码不一致',
  tip_emial_success: '激活链接已发送到邮箱，请登录邮箱验证！',
  tip_register_sucess: '注册成功！',
  resend: '重新发送',
  tip_repass: '请再次输入密码',
  tip_pass_different: ' 两个密码不一致，请检查！',
  forget_pass_title: '忘记密码',
  phone_email: '手机号/邮箱',
  ph_phone_email: '请填写手机号/邮箱',
  new_pass: '新密码',
  ph_new_pass: '请填写新密码',
  complete: '完成',
  ph_account: '请填写账号',
  tip_pass_success: '密码修改成功！',
  ph_phone_email1: '请输入手机号或邮箱',
  ph_password: '请输入密码',
  ph_auth: '请选择用户',
  ph_project_id: '请输入项目ID',
  ph_project_name: '请输入项目名称',
  ph_check_batch_id: '请输入验收批次ID',
  ph_check_status: '请选择验收状态',
  ph_inspector: '请选择验收员',
  ph_date: '请选择日期',
  ph_auth_uid: '请选择想登录的账号',
  ph_check_proportion: '请输入正确的抽检比例',
  ph_team: '请选择团队',
  get_user_list_success: '获取人员列表成功',
  tip_kick: '点击确认，其他登录设备登录的账户将无法继续使用。',
  continue_login: '继续登录',
  request_failed: '请求失败!',
  search: '搜索',
  reset: '重置',
  ok: '确定',
  cancel: '取消',
  confirm: '确认',
  export: '导出',
  start_time: '开始时间',
  end_time: '结束时间',
  // frame
  token_error: 'token异常',
  home_page: '主页',
  home_page2: '概览',
  home_page_tab1: '用户分布',
  home_page_tab2: '数据统计',
  home_page_tab3: '项目总览',
  home_page_active_user: '当前在线用户',
  home_page_active_team: '当前在线团队',
  config_management: '配置管理',
  base_config: '基本配置',
  link_config: '环节配置',
  model_management: '模型管理',
  add_model: '添加模型',
  edit_model: '编辑模型',
  model_name: '模型名称',
  oss_address: 'OSS地址',
  ph_model_name: '请输入模型名称',
  ph_oss_address: '请输入OSS地址',
  proxy_path: '代理路径',
  ph_proxy_path: '请输入代理路径',
  remark: '备注',
  ph_remark: '请输入备注',
  confirm_delete_model: '确定删除该模型吗？',
  region_frame_type_management: '区域帧类型管理',
  add_region_frame_type: '添加区域帧类型',
  edit_region_frame_type: '编辑区域帧类型',
  type_name: '名称',
  ph_type_name: '请输入名称',
  export_name: '导出名',
  ph_export_name: '请输入导出名',
  mode: '模式',
  ph_mode: '请选择模式',
  mode_all: '全部',
  mode_event_frame: '时间段',
  mode_key_frame: '关键帧',
  time_range_config: '默认帧范围',
  default_frame: '默认帧',
  ph_start_time: '起始帧',
  ph_end_time: '结束帧',
  ph_frame_count: '帧数',
  time_range_invalid: '起始帧不能大于等于结束帧',
  segment_length: '默认段长度',
  region_frames: '区域帧',
  ph_region_frame_type: '请选择区域帧类型',
  add_region_frame: '添加区域帧',
  no_region_frame_types: '暂无区域帧类型数据，无法添加',
  region_frame_name_required: '请为每个区域帧选择类型名称',
  region_frame_name_duplicate: '区域帧类型名称不能重复',
  shortcut_key: '快捷键',
  ph_shortcut_key: '点击输入快捷键',
  new_project: '新建项目',
  improt_export_rules: '数据导入导出规则',
  pm: '项目经理',
  pm_operation_manual: 'PM操作手册',
  supplier_operation_manual: '团队操作手册',
  operator_operation_manual: '作业员操作手册',
  acceptance_operation_manual: '验收员操作手册',
  exit: '退出登录',
  exit_success: '退出成功',
  bind_dingtalk_account: '绑定钉钉',
  dingtalk_account: '钉钉账号',
  ph_dingtalk_account: '请填写钉钉账号',
  footer_text: '©版权所有： 北京海天瑞声科技股份有限公司 京ICP备12041558号-1',
  // 创建1
  project_type: '项目类型',
  fusion_project: '标注',
  segmentation_project: '分割',
  shibiao_project: '试标项目',
  formal_project: '正式项目',
  project_desc: '项目描述',
  ph_project_desc: '请填写项目描述',
  start_end_date: '起止日期',
  required_filed: '必填项',
  associated_project: '关联项目',
  ph_hive_plactform: '请选择蜂巢平台中的项目',
  storage_address: '存储地址',
  project_member: '项目成员',
  none_selected_person: '未选人员',
  selected_person: '已选人员',
  optional_selected: '可选',
  selected1: '已选',
  save: '保存',
  next: '下一步',
  ph_project_type: '请选择项目类型',
  ph_associated_project: '请选择项目关联项目',
  ph_start_end_date: '请选择项目起止日期',
  ph_storage_address: '请选择存储地址',
  ph_platform_associated_project: '请选择工作平台的关联项目',
  ph_associated_project1: '请选择关联项目',
  project_create_message: '项目中如需接入预识别，请及时同步算法和平台研发!',
  prompt: '提示',
  project_create_message_ok: '我知道了',
  language: '语种',
  language_tip: '请选择语种',

  // 创建2
  tool_selection: '工具选择',
  user_selection: '用户选择',
  tool: '工具',
  ph_select: '请选择',
  ph_enter: '请输入',
  select: '选择',
  tip_to_tool_list: '可以查看和编辑（所有者）工具详细配置，被项目使用的工具只支持编辑部分配置',
  box_errors: '框错误组',
  ph_select_attr_template: '请选择框属性模板',
  refresh: '刷新',
  tip_create: '新建后需要点击刷新按钮',
  tip_refresh: '刷新后会重新加载列表',
  create_box_errors: '新建框错误组',
  maintain_box_errors: '维护框错误组',
  pic_invalid_reason: '数据无效原因',
  select_all: '全选',
  create_pic_invalid_reason: '新建数据无效原因',
  pre: '上一步',
  box_errors_management: '框错误组管理',
  pic_invalid_reason_management: '数据无效原因管理',
  ph_select_tool: '请选择工具',
  // 创建3
  add_link: '添加环节',
  type: '类型',
  name1: '名称',
  edit_link: '编辑环节',
  task_complete_time: '任务完成时间',
  rework_max_count: '返工最大次数',
  no: '否',
  yes: '是',
  allow_cross_rework: '允许操作跨级返工',
  not_allow_cross_rework: '不允许操作跨级返工',
  maintain_link: '维护环节',
  link_type: '环节类型',
  anno: '标注',
  annotation: '标注',
  quality_inspection: '质检',
  quality_inspect: '质检',
  link_name: '环节名称',
  link_name_duplicate: '环节名称重复',
  on: '开',
  off: '关',
  auto_recycling: '自动回收',
  link_desc_title: '创建环节说明',
  tip_create_link: '1、第一个环节必须是标注，标注之后必须是质检（即不可连续标注环节）；2、最后一个环节必须是质检；3、有任务不能增加或删除环节。',
  maintain_quality_inspection_strategy: '维护质检策略',
  ph_link_name: '请填写环节名称',
  anno_quality_inspection: '标注质检',
  ph_anno_quality_inspection_task: '请填写标注及质检任务',
  tip_first_not_qi: '第一个环节不可以是质检',
  ph_rework_max_count: '请填写返工最大次数',
  auto_recycling_title: '确定开启自动回收吗?',
  tip_auto_recycling: '可能有的任务早已达到回收条件，开关开启后可能马上就会被回收。',
  // 创建4
  rule_type: '规则类型',
  rich_text: '富文本',
  pdf_document: 'pdf文档',
  need_reread_by_marker: '是否需标注员重读',
  need: '需要',
  not_need: '不需要',
  upload_document: '上传文档',
  click_drag_upload: '点击或拖拽到区域上传',
  look_up_rule_file: '点击查看规则文件',
  ph_rule_content: '请填写规则内容',
  ph_upload_file: '请选择上传文件',
  ph_rule_countdown_second: '请填写规则倒数秒数',
  tip_save_rule_success: '保存规则成功！',
  tip_upload_file_size_10m: '上传文件大小必须小于10M',
  upload_file_success: '上传文件成功',
  // 创建5
  project_base_configuration: '项目基本配置',
  edit: '编辑',
  anno_type: '标注类型',
  mainten_person: '维护人员',
  tool_config: '工具配置',
  project_link_config: '项目环节配置',
  rework_recycling: '返工回收',
  close: '关闭',
  open: '开启',
  rule_content: '规则内容',
  click_to_view_rule: '点击查看规则',
  count_down: '倒计时',
  publish: '发布',
  project_rule: '项目规则',
  click_to_view_rule_file: '点击查看规则文件',
  tip_create_project_finished: '创建项目完成!',
  tip_project_publish_success: '项目发布成功',
  image_error: '图片错误',

  // 数据管理
  reject_reason: '驳回原因',
  labeler: '标注员',
  ph_labeler: '请输入标注员',
  quality_inspector: '质检员',
  ph_quality_inspector: '请输入质检员',
  picture_attr: '图片属性',
  ph_picture_attr: '请选择图片属性',
  data_link: '数据环节',
  ph_data_link: '请选择数据环节',
  data_status: '数据状态',
  header_data_status: '数据状态',
  ph_data_status: '请选择数据状态',
  pre_data_status: '上一轮验收数据状态',
  ph_pre_data_status: '请选择上一轮验收数据状态',
  acceptance_id: '验收ID',
  data_id: '数据ID',
  ph_acceptance_id: '请输入验收ID',
  ph_data_id: '请输入数据ID',
  ph_data_id_multiple: '请输入数据ID,多个使用","分隔',
  acceptance_task_status: '验收任务状态',
  ph_acceptance_task_status: '请选择验收任务状态',
  ph_acceptance_batch_status: '请选择验收批次状态',
  ph_acceptance_batch_id: '请输入验收批次id',
  data_effectiveness: '数据有效性',
  ph_data_effectiveness: '请选择数据有效性',
  effectiveness: '有效性',
  ph_effectiveness: '请选择有效性',
  keywords: '关键字',
  efficient: '有效',
  invalid: '无效',
  last_commit_time: '最后提交时间',
  last_edit_time: '最近编辑时间',
  object_count: '对象数',
  question_accuracy: '题点准率',
  cumulative_duration: '总耗时（秒）',
  speed: '倍速（秒/对象）',
  batch_pass: '批量通过',
  batch_reject: '批量驳回',
  batch_recycling: '批量回收',
  submit_acceptance: '提交验收',
  items_selected: '选中了 {num} 条数据',
  import_file_list_search: '导入搜索',
  apply_search_result: '应用于搜索结果',
  batch_submit_check: '分包提验',
  data_have_been_queried: '已查询到{num}条数据',
  submit_record: '提交记录',
  reject_which_session: '请选择驳回至哪个环节',
  ph_recycling_method: '请选择回收方式',
  clear_result: '清空结果',
  keep_result: '保留结果',
  tip_clear_result1: '回收到标注池：指数据重置为标注初次领取的状态，如果有算法预识别，则加载预识别的结果。如没有预识别，则不带任何标注结果。',
  tip_clear_result2: '同环节回收：不支持清空结果。',
  tip_keep_result1: '回收到标注池和同环节回收：均保留最新的标注结果、质检和验收结果、质检和验收意见、批注等所有信息。',
  tip_keep_result2: '',
  batch_name: '批次名称',
  file_name: '文件名',
  ph_file_name: '请输入文件名',
  ph_file_name_multiple: '请输入文件名,多个使用","分隔',
  submission_type: '提交类型',
  confirm_pass_search_result: '确定是否通过已搜索结果?',
  confirm_pass_choose_result: '确定是否通过已选中数据?',
  ph_reject_link: '请选择驳回环节',
  confirm_reject_search_result: '确定是否驳回已搜索结果?',
  confirm_reject_choose_result: '确定是否驳回已选中数据?',
  confirm_recycling_search_result: '确定是否回收已搜索结果?',
  confirm_recycling_choose_result: '确定是否回收已选中数据?',
  confirm_submit_search_result: '确定是否提交验收已搜索结果?',
  confirm_submit_choose_result: '确定是否提交验收已选中数据?',
  confirm_assign_search_result: '确定分配已搜索结果中的所有数据？',
  confirm_assign_choose_result: '确定分配已选中的数据？',
  batch_operate_count_prefix: '本次操作的数据数量为 ',
  batch_operate_count_suffix: '，是否确认',
  data_count_unit: '条数据',
  ph_upload_csv_format: '请上传csv格式的文件',
  tip_only_one_file_upload: '只能上传一个文件',
  release_message: '同环节定向释放：',
  release_ph: '可选择同环节的其他终端人',
  release_multiple: '批量释放',
  reject_multiple: '批量驳回',
  examine_multiple: '批量抽检',
  operation_successful: '操作成功',
  release_error_message: '只有同环节的数据才能批量释放！',
  reject_error_message: '只有同环节同状态的数据才能批量驳回！',
  if_save_result: '是否保留结果',
  recycle_to_mark: '回收到标注池',
  recycle_in_same_link: '同环节回收',
  recycle_method: '回收方式',
  tip_recycle_method1: '回收到标注池：回收到最初始的标注池，标注和质检均回收，验收不回收。',
  tip_recycle_method2: '同环节回收：回收到同环节的数据池。若处于标注环节则回收标注任务；若处于质检环节则只回收本环节的质检任务；若处于返修中则从返修环节到后续的环节均回收，比如标注返修中，则标注和质检均回收，验收不回收。',
  ph_save_result: '请选择是否保留结果',
  sure_delete_batch: '确定删除批次吗？批次删除后将不可恢复，请谨慎操作。',

  // 项目管理-统计
  last_update_time: '上次更新时间：',
  click_link: '点击链接',
  project_progress: '项目进度',
  supplier_progress: '团队进度',
  person_progress: '人员进度',
  project_data_statistic: '项目数据统计',
  supplier_data_statistic: '团队数据统计',
  person_data_statistic: '人员数据统计',
  project_pass_rate: '项目合格率',
  supplier_pass_rate: '团队合格率',
  person_pass_rate: '人员合格率',
  attribute_statistic: '属性统计',
  person_staff: '人员时薪',
  submitted_today: '当日提交数据',
  submitted_today_object: '当日提交元素',
  submitted_today_object_ai: '当日提交元素(预识别)',
  work_time_today: '当日工作时长',
  price_today: '当日时薪',
  export_curr_page: '导出当前页',
  total_data: '数据总量',
  anno_not_collected: '标注未领取',
  submitted: '已提交',
  acceptance: '验收',
  instance_type: '实例类型',
  label_options: '标签选项',
  batch_name_colon: '批次名称：',
  ph_project_session: '请选择项目环节',
  session: '环节',
  total: '合计',
  total_submit: '总提交量',
  invalid_data: '无效数据',
  empty_group: '空组',
  group: '组',
  no_config: '暂无配置',
  other: '其他',
  anno_rule_setting: '标注规则设置',
  anno_rule_setting_tip: '如果不选择标注规则，表示不使用标注规则',
  ph_rule: '请选择规则',
  ph_version: '请选择版本',
  whether_config_group_element: '是否配置组元素',
  group_element: '组元素',
  level_x: '第{value}层级',
  no_eligible_statistic: '无符合条件的统计数据',
  search_complete: '搜索完成',
  today_submission: '今日新增提交',
  today_duration: '当日工作时长（小时）',
  under_repair: '返修中',
  terminal_person_colon: '终端人：',
  terminal_person: '终端人',
  ph_terminal_person: '请输入终端人',
  ph_batch_name: '请选择批次名称',
  ph_enter_batch_name: '请输入批次名称',
  once_pass_rate: '一次合格率',
  two_time_pass_rate: '二次合格率',
  three_time_pass_rate: '三次合格率',
  four_time_pass_rate: '四次合格率',
  project_link_pass_rate: '项目环节合格率',
  project_batch_pass_rate: '项目批次合格率',
  project_batch_success_rate: '项目批次通过率',
  pre_identification_statistics: '有预识别统计',
  pre_identification_statistics_no: '无预识别统计',

  // 质检管理
  quality_management: '质检管理',
  quality_message: '抽检范围为标注&质检环节已提交的数据，进行中和返修中数据不参与抽检。',
  project_batch_colon: '项目批次：',
  project_batch: '项目批次',
  header_project_batch: '项目批次',
  ph_select_batch: '请选择项目批次',
  project_session_colon: '项目环节：',
  ph_select_session: '请选择环节',
  submitter: '提交人：',
  submitter1: '提交人',
  ph_select_submitter: '请选择提交人姓名',
  last_submit_time: '最后提交时间：',
  screening: '筛选',
  screening_count: '筛选数量：',
  quality_count: '抽检数量：',
  create_quality_task: '生成抽检任务',
  download_template: '点击下载导入返工图片模板',
  quality_batch_id: '抽检批次ID',
  submit_date: '提交日期',
  creator: '创建人：',
  header_creator: '创建人',
  image_pass_rate: '图片合格率',
  release: '释放',
  tip_quality_count: '请输入合理的抽检数量！',
  header_quality_count: '已驳回/已质检/总抽检量',
  multiple: '批量',
  multiple_operate_unqualified_data_content: '确定批量{name}本任务下全部未质检的数据？',
  multiple_confirm: '确定批量',
  tip_quality: '本任务下全部未质检的数据？',
  tip_copy_success: '复制成功！',
  tip_data_error: '数据没有申领成功，原则上不会出现这种情况，请联系管理员！',
  view_example: '查看示例',

  // 验收管理
  check_management: '验收管理',
  check_pending: '待验收',
  check_in: '验收中',
  check_submit: 'PM已提交',
  acceptance_passed: '验收通过',
  acceptance_rejected: '验收驳回',
  check_rate: '验收合格率',
  ph_select_check_batch: '请选择批次',
  ph_select_team: '请选择团队',
  image_filter_count: '筛选图片数：',
  check_count: '提交验收数：',
  submit_check: '提交验收',
  select_check_count: '选中{count}条数据',
  single_check_batch_count: '单个验收批次数据量 * 批次数',
  message_batch_count: '请输入合理的批次数！',
  message_single_batch_count: '请输入合理的单个验收批次数据量！',
  message_batch_max_count: '提交数据量必须小于选中的数据量！',
  image_count: '图片数量',
  undo: '撤销',
  submit_total: '驳回数据量/提交总量',
  frame_count: '总帧数',
  sampling_count: '抽检数量',
  header_check: '实际验收图片/实际验收对象',
  header_check1: '实际验收视频/实际验收对象',
  data_right_rate: '图片合格率',
  object_right_rate: '对象合格率',
  check_batch_status: '验收批次状态',
  submit_time: '提交时间',
  check_start_time: '开始验收时间',
  acceptance_completion_time: '验收完成时间',
  check_cost_time: '验收耗时',
  batch_data_receive: '数据领取',
  submit_times: '提交次数',
  ph_submit_times: '请输入提交次数',

  // inspector1: '验收人',
  houer: '小时',
  minute: '分钟',
  second: '秒',
  day: '天',
  tip_no_check: '没有可验收的图片/对象',
  tip_undo_success: '撤销成功',
  tip_sampling_count: '请输入合理的抽检数量！',
  batch_inspection: '整批提验',
  reject_recheck: '驳回数据复验',
  submit_check_msg: '请仔细检查您的提验选项，确保符合项目要求，诚信操作。若因勾选错误导致的验收问题，平台无法负责。确定提验吗？',
  ph_submit_check_msg: '特别提醒：“驳回数据复验”仅会提验上轮次验收驳回数据，其他数据不会提验，请按项目要求使用！',
  choose_check_data: '请选择提验数据',
  pass_data_recheck: '“验收通过”数据可再次被验收',
  inhreit_last_check_config: '继承上次抽检配置',
  ph_pass_data_recheck: '当配置开启，验收端可以更改上轮次“验收通过”数据的验收结果；当配置关闭，上轮次“验收通过”数据仅参与抽检和统计，验收结果不可更改。',
  ph_inhreit_last_check_config: '当配置开启，按照上轮次的“抽检比例”和“是否包含无效数据”自动生成抽检任务；当配置关闭，验收端手动配置“抽检比例”和“是否包含无效数据”。',
  ph_reject_recheck: '仅提验上轮次验收驳回数据，验收端仅允许验收驳回数据。',
  re_submit_check: '重新提验',

  // 待发布
  pic_single_fram_annotation: '图片单帧标注',
  pic_continuous_fram_annotation: '图片连续帧标注',
  pic_panoramic_semantic_egmentation_single: '图片全景语义分割-单帧',
  pic_panoramic_semantic_egmentation_continuous: '图片全景语义分割-连续帧',
  point_cloud_single_frame_annotation: '点云单帧标注',
  point_cloud_single_frame_fusion_annotation: '点云单帧融合标注',
  point_cloud_continuous_frame_annotation: '点云连续帧标注',
  point_cloud_continuous_frame_fusion_annotation: '点云连续帧融合标注',
  point_cloud_semantic_segmentation: '点云单帧语义分割',
  point_cloud_continuous_semantic_segmentation: '点云连续帧语义分割',

  project_released: '待发布项目',
  project_status: '项目状态',
  project_status_colon: '项目状态：',
  ph_project_status: '请选择项目状态',
  project_creator: '项目创建人',
  start_date: '开始日期：',
  header_start_date: '开始日期',
  end_date: '结束日期：',
  header_end_date: '结束日期',
  look_up_task: '查看任务',
  edit: '编辑',
  continue_create: '继续完善',
  batch: '批次',
  data_batch: '数据批次',
  send: '发布',
  annotation_send: '标注发布',
  quality_inspection_send: '质检发布',
  preview: '预览',
  task: '任务',
  pause_project: '项目暂停',
  task_statistic: '任务数据统计',
  clone_pro_config: '克隆项目配置',
  choose_checker: '选择验收人员',
  choose_export_model: '选择导出模板',
  export_batch_data: '导出批次数据',
  project_detail: '项目详情',
  edit_base: '编辑基本配置',
  edit_expand: '编辑拓展信息',
  edit_rule: '编辑规则信息',
  ph_select_checker: '请选择验收人',
  export_template: '导出模板',
  ph_export_template: '请选择导出模板',
  nmae_method: '命名方式',
  ph_name_method: '请选择文件命名方式',
  image_suffix: '图片后缀',
  ph_image_suffix: '请选择图片后缀',
  all: '全部',
  status_improvement: '待完善',
  status_publish: '待发布',
  confirm_project_publish: '确定要发布项目吗?',
  message_config: '需确保各项配置无误。',
  tip_project_start: '项目启动成功',
  confirm_project_clone: '确认克隆项目吗?',
  tip_export_template: '选择导出模板成功',

  // 进行中
  round_x: '第{value}轮',
  inspection_rounds: '检查轮次',
  check_pic_num: '检查图片数',
  check_obj_num: '检查对象数',
  error_pic_num: '错误图片数',
  error_obj_num: '错误对象数',
  error_rate: '错误率',
  feedback_record: '反馈记录',
  audit_records: '审核记录',
  close_algorithm_calls: '确定关闭算法调用吗?',
  close_algorithm_calls_content: '关闭后已进行预识别处理的图片不受影响，未进行预识别处理的图片将不再处理。',
  project_going: '进行中项目',
  ph_project_creator: '请输入项目创建人',
  ph_project_creator2: '请选择项目创建人',
  distribution: '分配',
  data_management: '数据管理',
  statistic: '统计',
  projet_pause: '暂停项目',
  projet_close: '结束项目',
  projet_close_confirm: '确认结束项目吗？',
  projet_clone: '克隆项目',
  export_data: '导出数据',
  export_list: '导出列表',
  algorithm_start: '算法配置',
  algorithm_close: '关闭算法调用',
  push_start: '关闭消息推送',
  push_close: '开启消息推送',
  clone_select: '请选择要克隆的信息：',
  message_clone: '注：新建项目第一步中的基本信息会默认复制；工具配置，环节配置和项目规则分别对应创建项目时该流程下的所有信息',
  algorithm_config: '请配置算法',
  ph_algorithm_config: '请选择算法',
  algorithm_add: '添加算法',
  algorithm_close2: '关闭算法',
  operation_success: '操作成功',

  // 算法abtest部分
  algorithm_name_version: '算法名称/版本',
  algorithm_config_add: '新增算法配置',
  algorithm_config_show: '标注页面显示配置',
  algorithm_field_config: '字段配置',
  algorithm_field_attribute: '算法属性字段',
  algorithm_field_tool: '工具属性字段',

  algorithm_show_modal_message: '请选择需要在标注真而显示开关的算法',
  algorithm_show_modal_name1: '自动贴合',
  algorithm_show_modal_name2: '智能追踪',
  algorithm_show_modal_name3: '插值计算',
  algorithm_show_modal_name4: '自动接地',
  ph_url: '请输入url',
  association_project: '关联项目',
  ph_association_project: '请输入关联项目编号',
  corresponding: '对应',
  algorithm_field_config_add: '添加配置',

  update_result: '更新结果',
  export_result: '导出结果',
  update_lastest: '上次更新时间',
  analysis_data: '数据倍速分析',
  analysis_object: '对象倍速分析',

  // 已完结
  project_finish: '已完结项目',
  more: '更多',
  project_reopen: '重开项目',
  data_statistic: '数据统计',
  header_total: '完成/总数',
  statue_in: '进行中',
  status_paused: '已暂停',

  // 终端人管理
  taggers_manager: '终端人管理',
  ph_name_account: '请输入姓名/账号',
  terminal_new: '新建终端人',
  disabled: '已禁用',
  normal: '正常',
  user_id: '用户ID',
  header_name: '姓名',
  account: '账号',
  header_create_time: '创建时间',
  last_login_name: '最后登录时间',
  tip_personnel_success: '获取人员列表成功',
  tip_personnel_status: '修改人员状态成功',
  disable: '禁用',
  assign_team: '指派团队',
  invalid_frame: '无效帧',
  invalid_frame1: '无效视频',
  invalid_data: '无效数据',

  // 验收人管理
  acceptor_management: '验收人管理',
  ph_company: '请输入公司名称',
  tacceptor_new: '新建验收人',

  // 团队管理
  team_management: '团队管理',
  team_name_colon: '团队名称：',
  header_team_name: '团队名称',
  ph_team_name: '请输入团队名称',
  mobile: '手机号：',
  ph_mobile: '请输入手机号',
  team_new: '新建团队',
  team_association: '团队账号关联',
  ph_hive: '请输入正确的蜂巢ID',
  organisation_id: '组织ID',
  hive_id: '蜂巢ID',
  team_cpunt: '团队人数',
  tip_association_success: '关联成功',

  // PM管理
  PM_management: 'PM管理',
  PM_new: '新建PM',

  // 工具配置
  delete: '删除',
  copy: '复制',
  none: '无',
  tool_new: '新建工具',
  tool_view: '查看工具',
  tool_edit: '编辑工具',

  id: 'ID',
  ph_id: '请输入ID',
  tool_name: '工具名称：',
  header_tool_name: '工具名称',
  ph_tool_name: '请输入工具名称',
  template_type: '模板类型：',
  header_template_type: '模板类型',
  ph_template_type: '请选择模板类型',
  used_project: '被项目使用：',
  header_used_project: '被项目使用',
  ph_used_project: '请选择是否被使用',
  confirm_edit_tool: '确定编辑工具吗？编辑后会影响进行中的项目数据，请谨慎修改。',
  confirm_delete: '确定删除吗？',
  tip_delete_success: '删除成功',

  submit: '提交',
  message_back: '返回上一步',
  confirm_back: '此操作会清空当前数据，确定返回上一步？',

  class_image: '图片类',
  use_now: '立即使用',
  class_3d: '3D类',
  range_circle: '范围圈',
  ph_range_circle: '请输入“整数”或“整数*整数”，多个范围圈请用“,”隔开，最多支持5个',
  message_range_circle: '“整数”：生成以此为半径的圆形范围圈; “整数*整数”：生成以此为长、宽的矩形范围圈',
  point_color: '点云着色方式',
  ph_point_color: '请选择点云着色方式',
  calibration_configuration: '校准配置',
  ph_calibration_configuration: '上传校准配置',
  box_config: '标注框属性配置',
  mapping_type: '映射类型',
  mapping_open: '是否映射',
  draw_independently: '独立绘制',
  consistent_size: '尺寸同步',
  pass_rate_stat_range: '合格率统计范围',
  stat_not_2d: '2D实例不计入',
  clond_on: '点在点云点',
  frame_config: '帧属性配置',
  other: '其他',
  segmented_load_4d: '4D分段加载',
  message_inspector_modify: '允许验收员修改标注数据',
  inspector_external_frame_switch: '验收关闭分割对象外接框',
  allow_repair_after_acceptance: '允许验收通过后返修',
  only_count_acceptance_frames: '仅统计验收帧',
  invalid_frames_not_statistics: '无效帧不参与统计',
  point_clouds_display_center: '点云按原始数据中心点显示',
  support_hand_drawn_qa: '支持手绘质检',
  frame_accuracy_requirements: '帧点准率要求',
  tip_verification_failed: '校验不通过！',
  label_config: '标签配置',
  overall_attr: '整体属性',
  tip_tool_name: '工具名称已存在',
  graphical_config: '图形配置',
  auto_copy_config: '自动复制配置',
  auto_copy_same: '同镜头帧之间开启自动复制',
  auto_copy_diff: '不同镜头之间开启自动复制',
  config_method: '配置方式',
  message_cover: '可复制其他图形的属性到本图形，如本图形中已有属性数据，则会覆盖。',
  tag_message_cover: '如同一个标签下需要绘制多种图形，需点此进行标签复制。',
  copy_attr: '复制属性',
  copy_label_attr: '标签复制',
  image_attr_config: '图片属性配置',
  default_display: '默认显示',
  defalut_display_tip: '勾选后，标注页面默认显示”整图属性“列表',
  select_sort: '按选中排序',
  select_sort_tip: '勾选后，有属性值的标签会前移',
  from_config_upload: '来源于配置上传',
  from_batch_upload: '来源于批次上传',
  batch_upload_tip: '校准配置需连同批次数据一并上传',
  support_drag_adjustment: '只映射不编辑',
  other_config: '其他配置',
  entire_attr: '整图属性',
  tip_image_tool: '请选择图形工具',
  confirm_cover: '标签复制会覆盖当前图形已添加的标签，是否继续复制？',
  tip_tools_same: '组元素配置的工具和图形配置的工具需要一致！',
  cloud_color: '点云颜色',
  depth_color: '深度颜色',
  reflectance_color: '反射率颜色',
  mapping_no: '无映射',
  mapping: '映射',
  box_2d: '2D框',
  box_25d: '2.5D框',
  associable: '可关联',
  associable_no: '不可关联',
  radio: '单选',
  checkbox: '多选',
  input: '输入框',
  radio_tiled: '平铺单选',
  radio_selection: '下拉单选',
  checkbox_tiled: '平铺多选',
  checkbox_selection: '下拉多选',
  support: '支持',
  support_no: '不支持',
  required: '要求',
  required_no: '不要求',
  graphics_same: '所有图形相同配置',
  graphics_diff: '不同图形不同配置',
  semantic_segmentation: '语义分割',
  object_segmentation: '实例分割',
  add_attr: '添加属性',
  use_config: '启用配置',
  input_setting: '输入框设置',
  message_chars: '字符个数>=',
  message_chars_and: '且<=',
  message_chars_number: '注：启用后会按照配置限制字符数，不启用表示没有限制',
  tip_empty: '{value}不能为空',
  tip_repeat: '{value}重复',
  tip_number: '只支持输入正整数',
  confirm_change_type: '切换类型会清空选项内容，请确认是否切换?',
  ph_min_chars: '请输入最小字符个数',
  ph_max_chars: '请输入最大字符个数',
  tip_max_chars: '最大字符个数不能小于最小字符个数',
  number: '序号',
  level: '级别',
  attr: '属性值',
  attr_name: '属性名称',
  name_display: '显示名',
  name_export: '导出名',
  label_attr: '标签属性',
  default_length: '默认长（米）',
  default_width: '默认宽（米）',
  default_height: '默认高（米）',
  attr_3d: '3D属性',
  attr_2d: '2D属性',
  attr_25d: '2.5D属性',
  division_type: '分割类型',
  whole_marking: '整图标注',
  input_required: '必填',
  default_item: '默认项',
  aassociated_category: '关联类别',
  is_single_attr: '是否逐帧属性',
  is_single_attr_tip: '若勾选，表示支持逐帧标注该属性，每一帧可有不同的属性值。只有此值相同的属性才能关联。',
  is_instance_attr: '是否实例属性',
  is_instance_attr_tip: '若勾选，表示实例ID的属性。适用于3D目标不存在但是2D存在，并且需要标注实例属性的场景。',
  associated_attr: '关联属性',
  attr_level: '属性层级',
  message_attr_level: '在标注页面展示该属性的层级值',
  message_color_clear: '“清空”颜色表示该属性无颜色，在标注页面不会填充',
  message_2d_node_color: '配置后，使用配置的颜色填充节点；若不配置，默认使用线的颜色填充节点',
  color_line: '允许颜色应用到线',
  color_node: '颜色应用到节点',
  message_color_line: '开启后，可在标注页面手动配置对象边框的颜色是否与属性颜色一致，支持矩形框、多边形、线段、点和立体框的颜色同步。',
  message_2d_node_line: '开启后，使用对应属性的颜色填充节点；不开启，默认使用线的颜色填充节点',
  message_2d_node: '开启后，使用对应属性的颜色填充节点；不开启，使用默认颜色填充节点',
  verify_attr: '校验ID属性一致',
  message_verify_attr: '该校验搭配“自动复制配置”使用，即开启同镜头帧之间自动复制，会校验同镜头帧之间同ID属性一致；开启不同镜头之间自动复制，会校验不同镜头之间同ID属性一致。',
  hot_key: '快捷键',
  color: '颜色',
  node_attr_conig: '节点属性配置',
  object_attr_conig: '对象属性配置',
  detection_box_attr_conig: '检测框属性',
  association_attr_conig: "组关系属性配置",
  spline: '曲线',
  statistics_without_pre_anno: '预标注对象不参与统计',
  is_allow_off_side: '是否允许出界',
  single_receive_count: '标注环节单次领取数量',
  ph_single_receive_count: '请输入标注环节单次领取数量',
  hang_count: '挂起数量',
  hang_count1: '挂起数',
  ph_hangup_count: '请输入挂起数量',
  message_integer: '请输入正整数',
  import: '导入',
  import_confirm: '导入后将覆盖原有配置，确认导入吗？',
  enum: '类型错误，仅支持：',
  name_empty: '不能为空',
  import_error_title: '导入失败，存在以下错误：',
  import_error_hot_key: '快捷键重复',
  import_error_empty: '无内容可导入，请检查导入文件的sheet名称是否正确。',
  import_error_only: '只能有一个',
  download_template: '下载模板',
  import_success: '导入成功！',
  import_success_link: '导入成功！若需要关联关系，请在平台手动配置！',
  import_upload_tip: '选中哪个对象类型，下载哪个对象类型的模板',
  import_tip: '选中哪个对象类型，导入哪个对象类型的属性配置',
  unit_price: '单价',
  rmb: '元',
  mask_image: 'Mask图',
  frame_attributes: '帧属性',
  box_2d: '2D框',
  box_25d: '2.5D框',
  box_3d: '3D框',
  polygon_3d: '3D多边形',
  polyline_curve: '折线和曲线',
  sse_price: '分割单价',
  sse_frame_price: '帧属性单价',
  ocr_tip: '开启后，根据项目配置的语种进行OCR识别',
  width_height_rate_error: '请输入正确的宽高比！',
  width_height_rate_tip: '比例请以英文:分隔，比如2:1，不输入表示不限定宽高比',

  // 数据规则
  your_upload_address: '你的上传地址',
  data_rules: '数据规则',
  data_rules_import: '数据导入规则',
  data_rules_export: '数据导出规则',
  data_rules_new: '新建导入规则',
  data_rules_management: '维护导入规则',
  number2: '编号',
  attr_parent_name: '父属性名',
  attr_parent_value: '父属性值',
  attr_sub_name: '子属性名',
  attr_sub_value: '子属性值',
  description: '描述',
  header_update_time: '更新时间',
  ph_rules_import_name: '请填写导入规则名称',
  ph_rules_import_description: '请填写导入规则描述',
  confirm_delete_attr: '确定删除该错误属性组吗?',
  message_delete_attr: '需确保删除该错误属性组不会影响现有项目',
  confirm_clone_attr: '确认克隆错误属性组吗?',
  message_clone_attr: '克隆该属性组中的所有属性及其关系',
  export_rules_config: '维护导出规则',
  ph_rules_export_name: '请填写导出规则名称',
  ph_rules_export_description: '请填写导出规则描述',
  error_attributes: '错误属性值列表',
  new_error_attribute: '新建错误属性',
  eidt_error_attribute: '维护错误属性值',
  attr_value_name: '属性值名称',
  error_type: '错误类型',
  version_management: '版本管理',
  import_versions: '导入版本管理列表',
  new_import_version: '新建导入版本',
  edit_import_version: '维护版本',
  json_version: 'JSON版本',
  ph_desc_rule: '请填写规则描述',
  ph_json_rule: '请填写JSON规则',
  export_versions: '导出版本管理列表',
  new_export_version: '新建导出版本',
  edit_export_version: '维护版本',
  ph_error_attr_value_color: '请填写错误属性值颜色',
  ph_error_attr_value_type: '请填写错误属性值类型',
  ph_error_attr_value_name: '请填写错误属性值名称',
  ph_error_attr_value_desc: '请填写错误属性值描述',
  image: '图片',

  // 框错误组
  error_management: '框错误组',
  error_management_new: '新建错误属性组',
  error_management_edit: '维护错误属性组',
  error_attr_new: '新建框错误属性',
  error_attr_edit: '维护错误属性',
  ph_error_name: '请填写错误属性名称',
  copy_success: '克隆成功',
  clone: '克隆',

  // 数据无效原因
  invalid_image: '数据无效原因',
  invalid_image_mew: '新建数据无效原因',
  invalid_image_edit: '维护数据无效原因',
  code: '编码',
  ph_invalid_image: '请填写数据无效原因名称',
  ph_invalid_image_description: '请填写数据无效原因描述',

  // 标注规则配置
  rules_config: '标注规则配置',
  rules_config_new: '新建标注规则',
  citation_records: '引用记录',
  message_rules_config: '用于标注时的规则设置。',
  description2: '说明',
  rules_config_edit: '维护标注规则',
  rules_name: '规则名称',
  ph_rules_name: '请填写规则名称',
  config_id: '配置ID',
  version_current: '当前使用版本',
  citations_number: '引用次数',
  version_number: '版本号',
  citations_time: '引用时间',
  version: '版本',
  ph_rules_config_name: '请填写标注规则名称',
  ph_rules_config_content: '请填写标注规则内容',
  tip_rules_save: '保存标注规则成功！',
  select_scene: '请选择场景',

  // 公告管理
  announcement_management: '公告管理',
  announcement_publish: '发布公告',
  all_prople: '所有人',
  published: '已发布',
  publish_stop: '停止发布',
  announcement_edit: '维护公告',
  announcement_title: '公告标题',
  announcement_scope: '通知范围',
  announcement_content: '公告内容',
  announcement_details: '公告详情',
  announcement_id: '公告ID',
  title: '标题',
  status: '状态',
  ph_announcement_title: '请填写公告标题',
  ph_announcement_content: '请填写公告内容',
  tip_announcement_save: '保存公告成功！',
  tip_announcement_edit: '修改状态成功！',

  // 管理日志
  management_log: '管理日志',
  log_id: '日志ID',
  user_name: '用户名',
  management_description: '操作描述',

  // 导出记录
  export_records: '导出记录',
  export_new: '新建导出',
  local_download: '本地下载',
  export_batch: '导出批次',
  ph_export_batch: '请选择导出批次',
  export_format: '导出格式',
  ph_export_format: '请选择导出格式',
  naming_method: '命名方式',
  ph_naming_method: '请选择命名方式',
  mask: 'mask图',
  mask1: '马赛克',
  export_no: '不导出',
  raw_data: '原始数据',
  export_dest: '导出目的地',
  export_oss: '导出到OSS',
  export_local: '导出到本地',
  export_data_volume: '导出数据量',
  search2: '查询',
  message_search: '共查询到{num}条',
  export_time: '导出时间',
  export_status: '导出状态',
  export_success: '导出成功',

  // 批次管理 gpt
  excluding_data_rechecked: '不含待复检数据',
  including_data_rechecked: '含待复检数据',
  last_round_inspector: '上一轮验收员',
  ph_last_round_inspector: '请选择上一轮验收员',
  data_to_be_rechecked: '待复验数据',
  ph_data_to_be_rechecked: '请选择待复验数据',
  quantity_to_be_rechecked: '待复验数量',
  min_sampling_rate: '图片最低抽检比例',
  ph_min_sampling_rate: '请填写图片最低抽检比例',
  tip_min_sampling_rate: '请输入【0,100】之间的整数',
  enabled_or_not: '是否启用',
  tip_close: '选择“关闭”表示不限制抽检比例。',
  tip_save_sampling_rate_success: '保存质检策略成功！',
  project_batch_management: '项目批次管理',
  refresh_batch: '刷新批次',
  add_batch: '添加批次',
  unmarked: '未标注',
  not_qa: '未质检',
  not_qa_message: '该批次下尚未开始质检的数据',
  message_batch_total: '该批次下尚未被标注员领取的数据总量',
  data_waiting_upload: '等待上传',
  pause: '暂停',
  annotation_pause: '标注暂停',
  quality_inspection_pause: '质检暂停',
  quality_inspection_strategy: '质检策略',
  empty_data: '清空数据',
  pre_recognition_toggle: '',
  import_rules: '导入规则',
  select_import_template: '请选择导入模板',
  select_import_version: '请选择导入版本',
  version_details: '版本详情',
  upload_type: '上传类型',
  cos_path: 'COS路径',
  oss_path: 'OSS路径',
  zip_compression_package: 'Zip压缩包',
  local_path: '本地路径',
  fill_oss_path: '请填写路径',
  priority: '优先级',
  ph_priority: '请选择优先级',
  checkbox_setting: '是否校验框：',
  header_checkbox_setting: '是否校验框',
  batch_priority_instructions: '批次优先级说明：数字越大，优先级越高，如：优先级5>优先级1',
  oss_upload_instructions: 'OSS上传说明：请上传去掉预设OSS路径的路径，如去掉oss://speechocean-bj/，上传ocr_test/ocr-oss-upload/即可',
  edit_batch: '编辑批次',
  batch_path: '批次名称',
  copy_oss_address: '批次路径',
  import_version_details: '导入版本详情',
  version_description: '版本描述',
  json_details: 'JSON详情',
  // maintain_quality_inspection_strategy: '维护质检策略',
  upload_failed: '上传失败',
  fill_batch_name: '请填写批次名称',
  stop_batch_confirmation: '确定停止批次吗?',
  project_progress_not_counted: '项目进度统计中，已停止的批次不做统计。',
  // off: '关闭',
  // on: '开启',
  no_longer: '不再',
  will: '会',
  confirmation1: '确定',
  confirmation: '确定',
  pre_identify: '预识别',
  images_not_affected: '后已领取的图片不受影响，未领取的图片',
  show_pre_recognition_results: '显示预识别结果。',
  status_modified_successfully: '修改状态成功',
  batch_data_deleted: '您删除了该批次数据',
  file_size_limit_exceeded: '上传文件大小必须小于200M',
  single_file_upload_allowed: '暂时只能上传一个批次数据文件',
  stop: '停止',
  sample_data: '示例数据',
  frameNumber: '帧数',
  ground_algo_ornot: '是否进行地面识别',

  // 项目分配管理
  project_assignment_management: '项目分配管理',
  project_assignment: '项目分配',
  // all: '全部',
  staff: '人员',
  enable: '启用',
  // project_assignment: '项目分配',
  select_step: '选择环节',
  select_vendor: '选择团队',
  optional: '可选',
  selected: '已选',
  receiving_range: '领取范围',
  please_select_previous_step_vendor: '请选择上一环节团队',
  vendor_name: '团队名',
  please_select_step: '请选择环节',
  please_select_vendor: '请选择团队',
  confirm_delete_vendor_X: '确定删除团队【{name}】?',
  save_vendor_success: '保存团队成功！',
  batch_range: '批次范围',
  please_select_batch: '请选择可领取的批次，若不选择表示所有批次都可领取',

  // 公告中心
  noticeCenter: '公告中心',
  viewNotice: '查看公告内容',
  noticeDetails: '公告详情',
  publishTime: '发布时间',

  // 首页
  waiting_to_be_released: '待发布项目',
  project: '项目',
  in_progress: '进行中项目',
  completed: '已完结项目',
  data: '数据（图片）',
  to_be_labeled: '待标注',
  to_be_inspected: '待质检',
  to_be_reviewed: '待审核',
  to_be_accepted: '待验收',
  ongoing_project_stats: '正在进行中的项目统计',
  message_center: '消息中心',
  latest_announcement: '最新公告',
  total_amount: '总量（张）',
  daily_capacity: '日均产能（张）',
  progress: '进度',
  duration: '工期',
  deadline: '截止日期',
  in_progress_task: '进行中任务',
  completed_task: '已完结任务',
  pending_data: '待完成数据',
  completed_data: '已完结数据',
  project_name2: '项目名',

  // 团队人员管理
  maintain_user_groups: '维护用户组',
  personnel_management: '人员管理',
  enter_name: '请输入姓名',
  enter_account: '请输入账号',
  import_users_in_batch: '批量导入用户',
  import_user: '导入用户',
  upload_error: '上传文件有误',
  check_fail_reason: '请点击文件链接查看上传失败原因',
  check_fail_file: '点击查看上传失败文件',
  download_import_user_file: '点击下载导入用户模板',
  file_description: '文件说明',
  download_template_first: '请先下载导入模板，按照示例格式填写后修改上传。',
  last_login_time: '最后登录时间',
  file_size_limit: '上传文件大小必须小于10M',
  batch_upload_limit: '暂时只能上传一个批次数据文件',

  // 算法管理
  algorithm_management: '算法管理',
  algorithm_list: '算法列表',
  algorithm_call: '算法调用',
  interface_name: '接口名称',
  chinese_name: '中文名称',
  english_name: '英文名称',
  ph_interface_name: '请输入接口名称',
  ph_chinese_name: '请输入中文名称',
  ph_english_name: '请输入英文名称',
  use_count: '项目使用次数',
  developer: '开发者',
  ph_developer: '请输入开发者',
  interface_description: '接口描述',
  ph_interface_description: '请输入接口描述',
  interface_create: '新增接口',
  interface_edit: '编辑接口',
  ph_version2: '请输入版本',
  algorithm_name: '算法名称',
  algorithm_version: '算法版本',
  ph_algorithm_name: '请输入算法名称',
  ph_algorithm_version: '请输入算法版本',
  algorithm_open: '是否开启算法调用',
  result_analysis: '结果分析',
  data_volume: '数据量',
  data_volume_tip: '对于单帧和连续帧，数据量均以数据条数为单位，单帧一张图片是一条数据，连续帧一个片段是一条数据。',
  control_group_flow_ratio: '对照组流量配比(%)',
  control_group_flow_ratio_tip: '对照组指不调用算法的流量。',
  ph_data_volume: '请输入数据量',
  ph_control_group_flow_ratio: '请输入流量配比',
  remaining_data_calling: '剩余数据是否调用算法',
  data_calling: '是否调用算法接口',
  data_calling_tip: '预识别算法请开启此配置，实时算法和客户的预识别数据请关闭此配置',
  static_num: '标注提交数据/提交帧数',
  static_num_qa: '提交数据/提交帧数',
  static_time: '倍速（s/帧）',
  static_hour: '倍速（帧/时）',
  one_static_num: '第一轮返修提交数据/提交帧数',
  one_static_time: '第一轮返修倍速（s/帧）',
  one_static_hour: '第一轮返修倍速（帧/时）',
  data_volume_frame: '总数据量/总帧数',
  all_object_num: '总框数',
  all_time: '总时长（秒）',
  acceptance_all_time: '验收总时长（秒）',
  tip_field: '请配置字段的对应关系',

  // 团队项目管理
  project_management: '项目管理',
  input_project_id: '请输入项目ID',
  input_project_name: '请输入项目名称',
  personnel: '人员',
  link: '环节',
  rejected_submitted: '被驳回/总提交',

  // 团队数据管理
  data_process: '数据环节：',
  select_data_process: '请选择数据环节',
  select_data_status: '请选择数据状态',
  select_terminal_user: '请选择终端人',
  found_x_data: '找到{num}条数据',
  select_date: '请选择日期',
  upload_import_image: '上传导入图片',
  import_image: '导入图片',
  click_download_template: '点击下载导入返工图片模板',
  terminal_user: '终端人',

  // 人员
  project_personnel_management: '项目人员管理',
  add: '添加',
  add_personnel: '添加人员',
  select_user: '选择用户',
  personnel_statistics: '人员统计',
  join_time: '加入时间',
  completion: '完成/总数',
  avg_daily_output: '平均日产量(图片)',
  avg_error_rate: '平均错误率(对象)',
  avg_rework_rate: '平均返工率(任务)',
  select_terminal_person: '请选择终端人',
  add_user_success: '添加用户成功！',
  save_personnel_success: '保存人员成功！',
  maintenance_user: '维护用户',
  role: '角色',
  ph_role: '请选择角色',
  ph_reset_password: '请输入重置密码',
  team_number: '团队编号',
  ph_team_number: '请输入团队编号',

  // 团队统计
  submit_progress: '提交进度',
  data_statistics: '数据统计',
  update_statistics: '更新统计',
  export_statistics: '导出统计',
  upload_import_images: '上传导入图片',
  today_new_submissions: '今日新增提交',
  total_submissions: '总提交量',
  invalid_images: '无效图片',

  // 消息中心
  notice_detail: '公告详情',
  message_status: '消息状态',
  selected_X: '选中了{num}项',
  mark_as_read: '批量设已读',
  unread: '未读',
  read: '已读',
  content: '内容',
  time: '时间',
  NO: 'NO',

  // 公告中心
  notice_center: '公告中心',
  view_notice: '查看公告内容',
  publish_time: '发布时间',

  // 质检管理 质检端
  quality_control_scope: '质检范围',
  select_submitter: '请选择提交人',
  last_submission_time: '最后提交时间',
  sample_quantity: '抽检数量',
  generate_sample_task: '生成抽检任务',
  download_rework_template: '点击下载导入返工图片模板',
  sample_task_id: '抽检任务ID',
  submitted_data_percentage: '已提交的数据/总抽检量',
  passed: '已通过',
  rejected: '已驳回',
  enter_valid_sample_quantity: '请输入合理的抽检数量！',
  confirm_batch_quality_inspection: '确定批量X本任务下全部未质检的数据？',
  rectangle2: '矩形框',
  collector: '采集人',
  ph_collector: '请选择采集人',
  collection_upload_time: '采集上传时间',
  unlimited: '不限',
  // 其他
  batch_id: '批次ID',
  add_time: '添加时间',
  algorithm_invocation: '算法调用',
  oss_copy: '复制OSS地址',
  start_recognition: '开启预识别',
  stop_recognition: '关闭预识别',
  details: '详情',
  company: '公司',
  associate: '关联',
  maintain_inspector: '维护验收员',
  reset_password: '重置密码',
  fill_phone_or_email: '请填写手机号/公司邮箱',
  fill_company_name: '请填写公司名称',
  invalid_phone_or_email_format: '手机号/公司邮箱格式不正确',
  choose_user_role: '请填写选择用户角色',
  company_name: '公司名',
  save_success: '保存成功',
  attribute_configuration: '属性配置',
  edit_session_configuration: '编辑环节配置',
  header_total_pass: '未领取/数据总量/验收通过',
  same_3d_box_sizes_num: '同一3D框允许的尺寸个数',
  same_3d_box_sizes_num_tip: '0代表提交时不会校验同一3D框尺寸一致性；输入正整数提交时会校验尺寸一致性，比如输入2，代表同一对象在所有帧最多允许出现2种尺寸。',
  related_template: '关联模版',

  merge_max_frames: '点云叠加最大帧数',
  merge_max_frames_tip: '为保证操作流畅，请合理填写点云叠加的最大帧数，限定不超过50帧',
  auto_tracking_frames: '自动追踪最大帧数',
  auto_tracking_frames_tip: '为保证算法性能，请合理填写自动追踪的最大帧数，建议10-20帧',

  clear: '清空',

  goto_data_manager_list: '跳转到“数据管理”查看',

  Chinese: '中文',
  English: '英文',
  French: '法语',
  German: '德语',
  Korean: '韩语',
  Japanese: '日语',
  Traditional_Chinese: '繁体中文',
  Vietnamese: '越南语',
  Spanish: '西班牙语',
  Portuguese: '葡萄牙语',
  Italian: '意大利语',
  Arabic: '阿拉伯语',
  Thai: '泰语',
  Hindi: '印地语',
  Flat_Single_Select: '平铺单选',
  Dropdown_Single_Select: '下拉单选',
  Flat_Multiple_Select: '平铺多选',
  Dropdown_Multiple_Select: '下拉多选',
  Input_Box: '输入框',
  Format_Error: '格式错误',
  Missing: '缺少',
  Column: '列',
  Box_Template: '框模板',
  Polygon_Template: '多边形模板',
  Line_Template: '线模板',
  Curve_Template: '曲线模板',
  Point_Template: '点模板',

  operator: '作业员',
  is_off_shelf: '已下架',
  document_status: '文档状态',
  sort: '排序',
  create_time: '创建时间',
  last_change_time: '最新变更时间',
  create_document: '创建文档',
  edit_document: '编辑文档',
  off_shelf: '下架',
  document_name: '文档名称',
  ph_document_name: '请输入文档名称',
  document_address: '文档地址',
  ph_document_address: '请输入文档地址',
  document_desc: '文档描述',
  ph_document_desc: '请输入文档描述',
  visible_range: '可见范围',
  ph_visible_range: '请输入可见范围',
  confirm_delete_this_data: '确认删除这条数据吗？',
  pinToTop: '置顶',
  cancelToPin: '取消置顶',
  checkTagInfo: '多选类型下属性不能重复关联, 部分属性已重置，请检查！',
  checkInspectorInfo: '该验收批次已被"{name}"领取，继续操作可能会覆盖已有验收结果，确定继续吗？',
  checkInspectorInfo2: '数据ID{ids}所在验收批次已被{idsName}领取，继续操作可能会覆盖已有验收结果，确定继续吗？',
  date_type: '时间筛选',
  time_type_day: '日',
  time_type_week: '周',
  time_type_month: '月',
  time_type_quarter: '季度',
  time_type_year: '年',
  chart_analyze_left_1: '团队累计作业时长',
  chart_analyze_right_1: '团队每{type}作业时长',
  chart_analyze_left_2: '标注团队累计提交数据量',
  chart_analyze_right_2: '标注团队每{type}提交数据量',
  chart_analyze_left_3: '质检团队累计提交数据量',
  chart_analyze_right_3: '质检团队每{type}提交数据量',
  chart_analyze_left_4: '标注团队平均倍速',
  chart_analyze_right_4: '标注团队每{type}倍速',
  chart_analyze_left_5: '质检团队平均倍速',
  chart_analyze_right_5: '质检团队每{type}倍速',
  chart_analyze_left_6: '标注员累计提交数据量',
  chart_analyze_right_6: '标注员每{type}提交数据量',
  chart_analyze_left_7: '质检员累计提交数据量',
  chart_analyze_right_7: '质检员每{type}提交数据量',
  chart_analyze_left_8: '标注员平均倍速',
  chart_analyze_right_8: '标注员每{type}倍速',
  chart_analyze_left_9: '质检员平均倍速',
  chart_analyze_right_9: '质检员每{type}倍速',
  unit_frame: '帧',
  unit_speed: '个/s',
  unit_indivual: '个',
  chart_empty: '查询范围内暂无记录',
  chart_statistics_type1: '图像标注',
  chart_statistics_type2: '图像分割',
  chart_statistics_type3: '点云标注',
  chart_statistics_type4: '点云分割',
  points_count_2d: ' 2D-点',
  line_count_2d: ' 2D-线',
  rectangle_count_2d: '2D-矩形框',
  polygon_count_2d: ' 2D-多边形',
  pseudo_count_2d: ' 2D-2.5D框',
  points_count_2d3d: '融合标注-2D点',
  line_count_2d3d: '融合标注-2D线',
  rectangle_count_2d3d: '融合标注-2D矩形框',
  polygon_count_2d3d: '融合标注-2D多边形',
  pseudo_count_2d3d: '融合标注-2.5D框',
  point_count_3d: '点云点',
  line_count_3d: '点云线',
  object_count_3d: '点云立体框',
  polygon_3d: '点云多边形',
  VideoFramePrice: '视频帧属性',
  video_frame_price: '视频属性',
  video_key_price: '关键帧',
  class_video: '视频标注',
  embodied_video_annotation: '具身视频标注',
  bev_2d: 'Bev视角点云2D图标注',
  stepInfo: '请输入视频步长',
  step: '步长',
  robot_model: '机器人模型',
  ph_robot_model: '请选择机器人模型',
  video_attr_setting: '视频属性配置',
  table_list_show: '对象列表显示',
  clone_tip: '克隆后，需要重新配置项目人员后才可以发布',
  keyframe: '关键帧',
  eventsection: '时间段',
  recycle_error: '当前自动回收时间异常，请检查后再提交',
  file_pure_number_sort_tip: '文件名为纯数字，请按数字大小排序',
  file_pure_number_sort_modal_tip: '当前已选择按文件名的数字大小排序。如文件名非纯数字，会按默认方式排序，请确认是否继续上传！',
  assigned_suppliers: '分配团队',
  // 图片筛选标注工具
  image_screen_anno: '图片筛选标注',
  number_of_images_displayed_per_page: '每页显示图片数',
  ph_number_of_images_displayed_per_page: '请按行*列的格式输入，如 4*5',
  qa_number_of_images_displayed_per_page: '项目发布后此项配置不支持修改，可在预览页面提前查看',
  anno_page_show_attr_value_only: '标注页面仅显示属性值',
  modifiable: '项目过程中，此项可修改',
  hanged: '已挂起',
  datPprocessingRules: '数据处理规则',
  workflow: '工作流',
  coverable: '可覆盖',
  canBeCovered: '可被覆盖',
  // 强制处理
  forcedProcessing: '强制处理',
  note: '备注',
  addProcessing : '添加处理',
  processFile: '处理文件',
  processingClassification: "处理分类",
  ph_processingClassification: '请选择处理分类',
  executionStartTime: '执行开始时间',
  executionEndTime: '执行结束时间',
  processedNum: '已处理数量',
  operator1: '操作人',
  exceptionDetails: '异常详情',
  processingStarted: '开始处理',
  selectFile: "选择文件",
  lineNum: '行号',
  errorMsg: '错误提示',
  exportToCustomer: '导出到客户',
  pending: '待处理',
  processing: '处理中',
  processedSuccessfully: '处理成功',
  processingExceptions: '处理异常',
  forceInvalidation: '强制无效',
  forcedRejection: '强制驳回',
  exportAnnotations: '导出批注',
  numberOfFramesAwaitingAcceptance: '待验收帧数',
  numberOfFramesInAcceptance: '验收中帧数',
  numberOfFramesPassed: '通过帧数',
  numberOfFramesRejected: '驳回帧数',
  assignTeam: '指定团队',
  video_frame_attr_conig: "视频帧配置",
  subtask_attr_conig: "子任务配置",
  config_group: '配置组',
  group_name: '组名称',
  group_name_ph: '请输入组名称',
  add_config_group: '添加配置组',
  remove: '删除',
  filter_invalid_data: '过滤无效数据',
  oneClickVerification: '一键复验',
  assigned_at: '下发时间',
}
